// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1":"views-Home","76":"common","104":"views-Test","201":"mainServer","224":"assets","237":"pages","704":"components-test","962":"store"}[chunkId] + "." + {"1":"1bfb008f","76":"7a0a0644","104":"b126c823","201":"e33e9c2e","224":"b0af2dfc","237":"92b0876d","704":"b5824d28","962":"378bd887"}[chunkId] + ".css";
};